const generateSeoTitle = ({ template, jSlug, iSlug }) => {
  const slug = jSlug || iSlug;
  return slug ? `${slug}-resume-${template}-template` : `${template}-resume-template`;
};

export default generateSeoTitle;
